/// <amd-module name="TFS/Samples/MasterDetails/MasterDetailsSamples" />
import * as React from "react";
import { IPageStateHistoryService } from "VSS/Features/History";
import { IVssPageContext } from "VSS/Platform/Context";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { DetailsPanel, MasterPanel } from "VSSUI/MasterDetails";
import { BaseMasterDetailsContext, IMasterDetailsContext, MasterDetailsContext } from "VSSUI/MasterDetailsContext";
import { ITableRow } from "VSSUI/Table";
import { getPullRequestLayer } from "./LayerComponents/PullRequest/PullRequestLayer";
import { IPullRequest, pullRequestItemProvider as itemProvider } from "./SampleData";
import { TopMasterView } from "./TopMasterView";

export interface IMasterDetailsSamplesState {
    fullMasterDetails: boolean;
    masterDetailsContext?: IMasterDetailsContext;
}

export class MasterDetailsSamples extends VssComponent<{}, IMasterDetailsSamplesState> {
    private pageContext: IVssPageContext;
    private pageStateHistoryService: IPageStateHistoryService;

    constructor(props: {}, vssComponentContext: IVssComponentContext) {
        super(props, vssComponentContext);

        this.pageContext = vssComponentContext.pageContext;
        this.pageStateHistoryService = this.pageContext.getService<IPageStateHistoryService>("IPageStateHistoryService");

        this.state = {
            fullMasterDetails: false
        };

        const projectedState = this.pageStateHistoryService.getProjectedState();

        if (projectedState["pull-request"]) {
            const pullRequest = itemProvider.value.find(pr => pr.hashCode === projectedState["pull-request"]);
            if (pullRequest) {
                this.state = {
                    fullMasterDetails: true,
                    masterDetailsContext: new BaseMasterDetailsContext(getPullRequestLayer(pullRequest, this.pageContext), () =>
                        this.setState({ fullMasterDetails: false })
                    )
                };
            }
        }
    }

    public render() {
        const { fullMasterDetails, masterDetailsContext } = this.state;

        if (fullMasterDetails && masterDetailsContext) {
            return (
                <MasterDetailsContext.Provider value={masterDetailsContext}>
                    <div className="flex-row flex-grow scroll-hidden">
                        <MasterPanel />
                        <DetailsPanel />
                    </div>
                </MasterDetailsContext.Provider>
            );
        } else {
            return <TopMasterView itemProvider={itemProvider} onPullRequestSelected={this.onTopMasterItemSelected} />;
        }
    }

    private onTopMasterItemSelected = (event: any, pullRequestRow: ITableRow<IPullRequest>) => {
        const pullRequest = pullRequestRow.data;
        this.pushPullRequest(pullRequest);
    };

    private pushPullRequest = (pullRequest: IPullRequest) => {
        this.setState({
            fullMasterDetails: true,
            masterDetailsContext: new BaseMasterDetailsContext(getPullRequestLayer(pullRequest, this.pageContext), () =>
                this.setState({ fullMasterDetails: false })
            )
        });
    };
}

Components.add("master-details-sample-view", MasterDetailsSamples);
